import styled from 'styled-components'

import { theme } from 'lib/styleUtils'

const Label = styled.p`
  font-size: ${theme('fonts.sizes.s')};
  font-weight: ${theme('fonts.weights.semiBold')};
  ${props => props.marginLeft && `margin-left: ${theme('spacing.l')(props)};`}
  text-align: center;
`

export default Label
